<template>
  <div class="carousel">
    <transition-group name="carousel__item" tag="ul" class="carousel__list--pros">
      <li class="carousel__item" v-for="item in items" :key="item.id" :class="item.getToggleClass">
        <span>{{ item.text }}</span>
      </li>
    </transition-group>
    <img class="carousel__controls carousel__controls--left" v-on:click="previousSlide()" src="//styles.uk-tla.com/img/horizontal-arrow.svg" />
    <img class="carousel__controls carousel__controls--right" v-on:click="nextSlide()" src="//styles.uk-tla.com/img/horizontal-arrow.svg" />
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class';
import ListItem from '../../viewmodels/ListItem';
import { tokenService } from '../../services/TokenService';

@Component
export default class CarouselComponent extends Vue {
  @Watch('slideIndex')
  public onSlidesChanged() {
    this.showSlides();
  }

  @Prop({
    default: () => [
      'Quick, easy and reliable. Great car prices in under a minute.',
      'No obligation and no hassle. Approved dealerships only.',
      'Over 1 million UK car buyers have used our service in the last 18 years.']
  })
  public carouselLines!: string[];

  public slideIndex: number = 0;

  public slidesCount = 0;

  private items: ListItem[] = [];

  public interval = setInterval(() => {
    this.incrementSlider();
  }, 3000);

  public changeSlide(slideNumber: number) {
    if (slideNumber >= this.slidesCount || slideNumber < 0) {
      this.slideIndex = 0;
    } else {
      this.slideIndex = slideNumber;
    }
  }

  public incrementSlider() {
    this.changeSlide(this.slideIndex + 1);
  }

  public nextSlide() {
    clearInterval(this.interval);
    this.incrementSlider();
  }

  public previousSlide() {
    clearInterval(this.interval);
    if (this.slideIndex === 0) {
      this.slideIndex = 3;
      this.changeSlide(this.slideIndex - 1);
    } else {
      this.changeSlide(this.slideIndex - 1);
    }
  }

  public showSlides() {
    if (this.items !== null && this.items.length > 0) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        item.isActive = false;
      }
      this.items[this.slideIndex].isActive = true;
    }
  }

  public mounted() {
    this.items = this.carouselLines.map((a: string, i: number) => new ListItem(i, tokenService.replaceToken(a)));
    this.slidesCount = this.items.length;
    this.showSlides();
  }
}
</script>
